/* Guests (customer not logged in) cannot add anything to the cart (wholesale: prices and ordering are for logged-in customers).
   Loaded from snippets/head.liquid for guests only. The add buttons and steppers are also disabled in the markup and faded by CSS
   (`.is-guest`, end of theme.css); this is the backstop for everything those miss: keyboard, a variant change that re-enables a
   button, forms posting natively. Capture listeners run before the theme's own, so stopImmediatePropagation keeps them from seeing it. */
(function () {
  document.addEventListener('theme:cart:add', function (event) {
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
